import { CheckCircle, CircleOutlined } from "@mui/icons-material";
import { StepIconProps } from "@mui/material";

export const BookingStatusIcon = ({ active, completed }: StepIconProps) => {
  return completed || active ? <CheckCircle sx={{ fontSize: 40 }} /> : <CircleOutlined sx={{ fontSize: 40, color: "primary.main" }} />;
};
